import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  enTitle?: string;
  description?: string;
  morePath?: string;
  moreLabel?: string;
  light?: boolean;
}

export default function SectionHeading({
  title,
  enTitle,
  description,
  morePath,
  moreLabel = '查看更多',
  light = false,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          <h2 className={`text-xl font-bold tracking-tight md:text-2xl ${light ? 'text-background-50' : 'text-foreground-950'}`}>
            {title}
          </h2>
          {enTitle && (
            <span
              className={`mt-1 font-label text-xs uppercase tracking-[0.22em] ${
                light ? 'text-background-300/70' : 'text-foreground-400'
              }`}
            >
              {enTitle}
            </span>
          )}
        </div>
        {description && (
          <p className={`mt-2 text-sm ${light ? 'text-background-200/80' : 'text-foreground-500'}`}>{description}</p>
        )}
      </div>
      {morePath && (
        <Link
          to={morePath}
          className={`group inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm transition-colors ${
            light ? 'text-background-200 hover:text-accent-300' : 'text-foreground-500 hover:text-primary-600'
          }`}
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}